var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('Jumper',{attrs:{"size":90}})],1):_c('div',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }